import classNames from 'classnames';
import BaseInput from 'components/atoms/base-input';
import BaseInputNumber from 'components/atoms/base-input-number';
import BaseSelectBox from 'components/atoms/base-select-box';
import ExpandableFilterPanel from 'components/molecules/expandable-filter-panel';
import CareManagerRoles from 'constants/careManagerRoles';
import { type FC, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import useUser from 'utils/useUser';

import s from './styles.module.scss';
import { useFilter } from './use-filter';

interface ItemProps {
  label: string;
  children: ReactNode;
}
const Item: FC<ItemProps> = ({ label, children }) => (
  <div className={s['item-wrapper']}>
    <label>{label}</label>
    {children}
  </div>
);

const CareManagersFilter: FC = () => {
  const { isAdmin } = useUser();
  const { t } = useTranslation();
  const { filter, updateFilter, debouncedUpdateFilter, count, resetFilter } =
    useFilter();

  return (
    <ExpandableFilterPanel
      filtersCount={count}
      onReset={resetFilter}
      isExpanded
    >
      <div className={classNames(s.wrapper, { [s['is-admin']]: isAdmin })}>
        <Item label={t('labels.fullName')}>
          <BaseInput
            placeholder="Search"
            defaultValue={filter.fullName}
            onChange={(searchValue) => {
              debouncedUpdateFilter({ fullName: searchValue, page: 1 });
            }}
            allowClear
          />
        </Item>

        <Item label={t('labels.role')}>
          <BaseSelectBox
            options={CareManagerRoles}
            placeholder="Select"
            value={filter.clinicalRoles ?? 'all'}
            onChange={(v) => {
              updateFilter({
                clinicalRoles: v === 'all' ? undefined : v,
                page: 1,
              });
            }}
            allowClear
          />
        </Item>

        <div className={s['combine-item-wrapper']}>
          <Item label={t('labels.minPatientsAssigned')}>
            <BaseInputNumber
              min={0}
              placeholder="Min"
              max={filter.maxPatientsAssigned}
              value={filter.minPatientsAssigned}
              onChange={(v) => {
                debouncedUpdateFilter({ minPatientsAssigned: v, page: 1 });
              }}
            />
          </Item>
          <Item label={t('labels.maxPatientsAssigned')}>
            <BaseInputNumber
              placeholder="Max"
              min={filter.minPatientsAssigned}
              value={filter.maxPatientsAssigned}
              onChange={(v) => {
                debouncedUpdateFilter({ maxPatientsAssigned: v, page: 1 });
              }}
            />
          </Item>
        </div>
      </div>
    </ExpandableFilterPanel>
  );
};
export default CareManagersFilter;
